import { FC } from "react";
import ModuleSkeleton from "shared/components/ModuleSkeleton";
import { SkeletonCard } from "./styled";

const ThreeCardsSkeleton: FC = () => {
  return (
    <ModuleSkeleton>
      <SkeletonCard />
      <SkeletonCard />
      <SkeletonCard />
    </ModuleSkeleton>
  );
};

export default ThreeCardsSkeleton;
